var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandscape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.22 37.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #dadada;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path21178-04",
    className: "cls-3",
    d: "M117.07,14.27l-1.04,4.02v6.68h-9.55v-1.23h-1.21v-2.11h-1.8l-.12-.68h-2.96v-1.57h-.45v5.66h-1.11v-1.09h-.9v1.26h-3.15v-1.5h-4.68v-3.58h-.66v-.41h-.66l-.54.2v.51h-.38v1.26h-1.44l.24-.58h-1.58l.14.75h-1.09v4.23h-1.51v-2.93h-.97v2.39h-2.32l-.64-3.37-.66-.99h-3.31v-4.02l-.66-3.51-.66,3.55v6l-.88-.34v-1.84h-2.34v2.93h-.83v3.58h-1.66v-4.02h-1.06l-.59,3.17h-3.1v-5.11h-.69v2.73h-4.21v2.11s-.07.03-.12.07c-.88,1.23-2.2-.85-3.07.51-.43.92-.76,0-1.25-.17-.31.58-.88,1.09-1.58,1.23v-1.12h-1.04c-.28-.72-.8-1.3-1.63-.61-.17-.07-.33-.1-.5-.17v-3.24h-1.61c-.19-.17-.33-.41-.19-.72,0-1.09-1.47.03-1.66-.99-.28-.92-1.23-1.19-1.92-.61-.69.31-1.35.72-1.94,1.19v-.82h-.45v.58c-.17-.27-.38-.55-.73-.61-.64-.31-1.37-1.3-2.01-.95-.33.82-.76,1.6-1.18,2.39-.31,1.09-1.09.14-1.47.24-.83.2-.38,1.84-1.37,1.7-.73-.34-1.51-.07-1.82.78-.52.27-.83.1-1.02-.51-.5-.24-.76-.07-.92.27l-.35-.89-1.14,2.86-1.87-.72-.88-1.26h-1.8v3.89h-.97v-9.58l-1.06-.41v4.47h-2.86v5.11h-2.48v3.24h-1.51v-1.36h-3.64l-2.03-2.93-1.32,1.91h-3.76v1.84h-1.49v-1.64h-.76v2.93h-1.44v3.68H.26l-.26,1.7h301.22v-1.19l-.26-1.4-1.84-1.84v-1.67l-1.21-.48v-1.98l-1.54.61v2.15h-1.82v-.27h-1.82v-.17l-2.34,1.84v-1.47h-1.92c0-.2.02-.37.05-.58.17-.61-.43-.92-.71-1.12-.19-.68-.19-1.7-1.28-1.33-.19.48-.5.61-1.02.41v-1.02h-1.47l-.33-1.77h-1.35l-.19.95c-.4.07-1.04.55-1.32-.17-.43-.58-.85-1.16-1.18-1.77-.64-.24-1.37.51-2.01.72-.54.07-.73.55-.99.75-.64-.37-1.4-.75-2.13-.99-.66-.44-1.61-.24-1.92.44-.19.78-1.66-.07-1.66.75.35.72-1.37.75-.73,1.26-.07.41.92.75.14,1.06,0,.07.05.14.05.17h-.19l-.64-3.41-1.51.58-.38-2.05h-.97v3.58h-.83v-1.33h-1.58l-2.34.92v2.11h-1.68l-.28-1.57h-1.44v-8.18s-.28-.27-.76-.27,0,6.85,0,6.85h-1.42l-1.09-2.69-1.56,3.89-1.89-2.73-1.8,2.62h-.9v-1.64h-1.06v5.42h-.97v-3.07h-1.23l-.21-1.16h-1.14v1.3h-2.03v-2.18l-.9.34v-2.08h-.9v-.95h-.99l-.69-6.95-.52,6.82v4.87h-.9v-1.09h-2.41v3.37h-1.82v-2.28h-1.51v-5.22h-1.49v-.89h-1.32l-.78-1.98-1.28,3.17h-1.56v4.12h-.78v-2.25l-2.72-1.06v2.52h-1.54v-3.2h-2.51v2.39c-.12-.31-.31-.55-.54-.78.14-2.05-1.8-1.06-2.32-1.98-.9.03-1.25,0-1.11-1.3-.64-.95-2.41-2.56-3.59-1.09-.88,1.84-2.2-1.33-3.07.75-.43,1.36-.76,0-1.25-.24-.19.55-.47,1.02-.83,1.4v-.99h-.76v1.47c-.24.07-.5.07-.76,0-.07-.92-.61-4.3-1.92-2.62-.88-.51-2.01-.68-2.72.61-1.23-1.12-1.47,2.05-1.68,3.07-.17-.03-.33-.07-.47-.03h-.05c-.85.14-1.28,1.33-1.04,2.45h-.24v2.22h-2.18v-2.01l-1.61.61v-4.7l.38-.95v-1.47h-3.67v1.43l.5,1.23v4.19l-1.66.65v-1.6h-2.77v-1.77h-2.96v-2.69l-1.21-6.44-1.23,6.55v5.76h-1.54v-2.32h-4.16v1.64h-3.36v2.45h-2.18v-6.58h-1.54v3.65l-1.14-.44v-4.16h-1.49v2.15h-1.54v1.98h-2.13v1.98h-1.25l-.33-1.81h-1.61v-2.76h-1.14v-.99h-1.02l-1.09.07v3.31h-.78v-1.5l-.71-1.02-1.35,1.12v.1l-.64,3.03v-8.05h-1.06v6.07h-.8l-.35-1.91h-2.39v4.53h-1.14v-2.8l-.4-2.18h-2.39v5.69h-1.02v-2.15h-3.24v3.34l-1.77-9.55h-2.39l-.47,9.37h-2.03v-4.12l-.52-.2-.21-1.19h-3.93l-.5,2.69h-1.47v-1.57l-.66.27v4.53h-1.92v-7.47l-.95-.37v-3.2l-.9-4.77-.76,4.09h-.73l-1.14-4.36.02-.27ZM210.87,27.7v.2h-.09c.02-.07.07-.14.09-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3808-1",
    className: "cls-3",
    d: "M203.68,28.58v-6.06l-.48-.18-.5-5.61-.5,5.61-.48.18v6.06h1.99-.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5240",
    className: "cls-3",
    d: "M36.13,34.88v-11.13l.72-.21.13-.47c.47-.72.09-1.02,0-1.45-.26-.81-.21-1.62.64-2.39.13-.68.47-1.32,1.02-1.79v-2.05l.64-4.22.64,4.22v2.05c.6.47.9,1.11,1.02,1.79.85.77.85,1.58.64,2.39-.09.43-.47.72,0,1.45l.13.47.72.21v11.13h-6.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect5260",
    className: "cls-2",
    x: 37.83,
    y: 24.86,
    width: 0.94,
    height: 2.69
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5260-6",
    className: "cls-2",
    x: 39.71,
    y: 24.86,
    width: 0.94,
    height: 2.69
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path109413",
    className: "cls-3",
    d: "M63.71,34.78v-14.03l-.66-.39.94-.94,1.69-4,.09-.37v-1.44h-.53v-.16h.55v-1.03h.18v1.03h.55v.16h-.53v1.44l.09.37,1.69,4,.94.94-.66.39v14.03h-4.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4547-5",
    className: "cls-3",
    d: "M27.53,29.27v-2.93l-.62-.18v3.02l.62.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4547-2",
    className: "cls-3",
    d: "M30.23,28.86v-1.97l-.41-.11v2.01l.41.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rect21585",
    className: "cls-4",
    d: "M21.54,16.45l-8.49,6.41h-.16v.13l-.81.62h.81v3.32h.49l-.81,7.94h17.9v-11.1l-9.79,1.3v-1.43h10.18l-9.27-7.19h-.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21596"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012",
    className: "cls-4",
    points: "12.27 23.87 14.15 23.87 14.15 23.87 14.15 34.87 14.15 34.87 12.27 34.87 12.27 34.87 12.27 23.87 12.27 23.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012-7-3",
    className: "cls-4",
    points: "20.53 23.87 22.42 23.87 22.42 23.87 22.42 29.04 22.42 29.04 20.53 29.04 20.53 29.04 20.53 23.87 20.53 23.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012-7-9",
    className: "cls-4",
    points: "24.66 23.87 26.55 23.87 26.55 23.87 26.55 34.87 26.55 34.87 24.66 34.87 24.66 34.87 24.66 23.87 24.66 23.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012-7-5",
    className: "cls-4",
    points: "28.8 23.87 30.68 23.87 30.68 23.87 30.68 34.87 30.68 34.87 28.8 34.87 28.8 34.87 28.8 23.87 28.8 23.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21574",
    className: "cls-4",
    d: "M23.17,19.67c0,.88-.72,1.59-1.59,1.59s-1.59-.72-1.59-1.59h0c0-.88.72-1.59,1.59-1.59s1.59.72,1.59,1.59h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path4677-2",
    className: "cls-3",
    d: "M236.59,22.17c-1.58,0-3.16.68-4.73,2.03v9.99l17.62-.15v-9.84s-8.12.15-8.12.15c-1.58-1.43-3.16-2.14-4.73-2.18h-.04ZM261.69,22.17c-1.58,0-3.16.75-4.73,2.18l-7.74-.15v9.84l17.25.15v-9.99c-1.58-1.39-3.16-2.07-4.73-2.03h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4679-6",
    className: "cls-3",
    d: "M235.01,22.59c.19-.38,0-.79,0-1.16.23,0,.49-.19.68,0,.08-.68.11-1.32.08-1.99h-.26c-.15-.3-.08-.56,0-.83l-.3-.11v-.19h.3l.3.23v.53l.38.08c-.23-.26-.08-.53,0-.79h.3v.79h.19s-.04.23-.04.23h-.41s0,1.73,0,1.73l.45.11v.38h.26l.15-.23.38.08.15-.11.68-.08.08-.34.15.08v.38l-.19.41-.08.23c0,.34-.04.71-.23.75-.23-.15-.23-.41-.19-.68h-.53c0,.49-.04.45-.08.49h-.19v-.49h-.49c.08.15.11.26,0,.3h-.3c-.19-.11-.08-.23,0-.34h-.79v.38s-.45.19-.45.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-0",
    className: "cls-1",
    d: "M233.39,26.23c.45.19.9.19,1.35,0h0v-1.95h0c-.41-.08-.86-.19-1.35,0h0v1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-5",
    className: "cls-1",
    d: "M235.8,24.28c.45-.19.9-.19,1.35,0h0v1.95h0c-.41.08-.86.19-1.35,0h0v-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-7-9",
    className: "cls-1",
    d: "M238.32,24.28c.45-.19.9-.19,1.35,0h0v1.95h0c-.41.08-.86.19-1.35,0h0v-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-7",
    className: "cls-1",
    d: "M243.01,26.23c.26-.19.49-.19.75,0h0v1.95h0c-.23.08-.49.19-.75,0h0v-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-8-1",
    className: "cls-1",
    d: "M246.84,27.62c.23-.15.41-.15.64,0h0v1.62h0c-.19.08-.38.15-.64,0h0v-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4679-6-5",
    className: "cls-2",
    d: "M263.19,22.51c-.19-.38,0-.79,0-1.16-.23,0-.49-.19-.68,0-.08-.68-.11-1.32-.08-1.99h.26c.15-.3.08-.56,0-.83l.3-.11v-.19h-.3l-.3.23v.53l-.38.08c.23-.26.08-.53,0-.79h-.3v.79h-.19s.04.23.04.23h.41s0,1.73,0,1.73l-.45.11v.38h-.26l-.15-.23-.38.08-.15-.11-.68-.08-.08-.34-.15.08v.38l.19.41.08.23c0,.34.04.71.23.75.23-.15.23-.41.19-.68h.53c0,.49.04.45.08.49h.19v-.49h.49c-.08.15-.11.26,0,.3h.3c.19-.11.08-.23,0-.34h.79v.38s.45.19.45.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-0-4",
    className: "cls-1",
    d: "M264.92,26.23c-.45.19-.9.19-1.35,0h0v-1.95h0c.41-.08.86-.19,1.35,0h0v1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-5-4",
    className: "cls-4",
    d: "M262.48,24.28c-.45-.19-.9-.19-1.35,0h0v1.95h0c.41.08.86.19,1.35,0h0v-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-7-9-2",
    className: "cls-1",
    d: "M259.96,24.28c-.45-.19-.9-.19-1.35,0h0v1.95h0c.41.08.86.19,1.35,0h0v-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-7-8",
    className: "cls-1",
    d: "M255.26,26.23c-.26-.19-.49-.19-.75,0h0v1.95h0c.23.08.49.19.75,0h0v-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-8-1-8",
    className: "cls-1",
    d: "M251.43,26.42c-.23-.15-.41-.15-.64,0h0v1.62h0c.19.08.38.15.64,0h0v-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823",
    className: "cls-2",
    d: "M241.89,33.97h2.82v-2.37c0-1.73-2.63-2.22-2.82.04v2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-6",
    className: "cls-2",
    d: "M259.28,34.12h1.77v-1.5c0-1.09-1.65-1.39-1.77,0v1.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect4845-9",
    className: "cls-1",
    points: "241.06 25.14 257.7 25.14 257.7 25.14 257.7 25.44 257.7 25.44 241.06 25.44 241.06 25.44 241.06 25.14 241.06 25.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    className: "cls-3",
    d: "M171.41,5.59v.62h-.29v1.63l-1.14-.16.13,2.11c-3.81,1.5-4.1,4.03-4.59,6.51-.62.33-1.2.42-1.79-.07-.07-.33-.29-.55-.72-.68l-.07-1.01h-.85v1.07c-.94.23-1.04.98-1.33,1.56l-.42.07v.39l.55.16-.07,1.27-1.79-.07c-.36.1-.46.46-.46.88v7.65l-9.76-3.61-13.96-.13-.13,10.41h37.19c0-18.74-.49-18.74-.46,0h36.6v-10.28h-13.27l-9.79,3.61v-7.65c0-.42-.07-.78-.42-.88l-1.79.07-.07-1.27.59-.16v-.39l-.46-.07c-.33-.62-.36-1.37-1.33-1.56v-1.07h-.85l-.07,1.01c-.42.13-.65.36-.72.68-.59.49-1.2.39-1.79.07-.49-2.47-.78-5.01-4.59-6.51l.13-2.11-1.17.16.07-1.63h-.36v-.62h-.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020",
    className: "cls-1",
    points: "138.91 26.54 139.56 26.54 139.56 26.54 139.56 33.53 139.56 33.53 138.91 33.53 138.91 33.53 138.91 26.54 138.91 26.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8",
    className: "cls-1",
    points: "142.19 26.47 143.2 26.47 143.2 26.47 143.2 33.53 143.2 33.53 142.19 33.53 142.19 33.53 142.19 26.47 142.19 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6",
    className: "cls-1",
    points: "143.43 26.47 144.83 26.47 144.83 26.47 144.83 33.53 144.83 33.53 143.43 33.53 143.43 33.53 143.43 26.47 143.43 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4",
    className: "cls-1",
    points: "146.13 26.47 146.75 26.47 146.75 26.47 146.75 33.53 146.75 33.53 146.13 33.53 146.13 33.53 146.13 26.47 146.13 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-1",
    className: "cls-1",
    points: "148.25 26.47 148.86 26.47 148.86 26.47 148.86 33.53 148.86 33.53 148.25 33.53 148.25 33.53 148.25 26.47 148.25 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-2",
    className: "cls-1",
    points: "149.25 27.03 149.87 27.03 149.87 27.03 149.87 33.53 149.87 33.53 149.25 33.53 149.25 33.53 149.25 27.03 149.25 27.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-4",
    className: "cls-1",
    points: "150.26 27.29 150.88 27.29 150.88 27.29 150.88 33.53 150.88 33.53 150.26 33.53 150.26 33.53 150.26 27.29 150.26 27.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-21",
    className: "cls-1",
    points: "151.27 27.48 151.89 27.48 151.89 27.48 151.89 33.53 151.89 33.53 151.27 33.53 151.27 33.53 151.27 27.48 151.27 27.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-13",
    className: "cls-1",
    points: "152.18 27.71 152.8 27.71 152.8 27.71 152.8 33.53 152.8 33.53 152.18 33.53 152.18 33.53 152.18 27.71 152.18 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-10",
    className: "cls-1",
    points: "155.4 27.71 156.02 27.71 156.02 27.71 156.02 33.53 156.02 33.53 155.4 33.53 155.4 33.53 155.4 27.71 155.4 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-28",
    className: "cls-1",
    points: "156.41 27.71 157.03 27.71 157.03 27.71 157.03 33.53 157.03 33.53 156.41 33.53 156.41 33.53 156.41 27.71 156.41 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-3",
    className: "cls-1",
    points: "157.58 28.23 158.2 28.23 158.2 28.23 158.2 33.53 158.2 33.53 157.58 33.53 157.58 33.53 157.58 28.23 157.58 28.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45",
    className: "cls-1",
    points: "158.82 28.23 159.37 28.23 159.37 28.23 159.37 33.53 159.37 33.53 158.82 33.53 158.82 33.53 158.82 28.23 158.82 28.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2",
    className: "cls-1",
    points: "164.8 23.06 165.36 23.06 165.36 23.06 165.36 33.53 165.36 33.53 164.8 33.53 164.8 33.53 164.8 23.06 164.8 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-3",
    className: "cls-1",
    points: "166.63 23.06 167.18 23.06 167.18 23.06 167.18 33.53 167.18 33.53 166.63 33.53 166.63 33.53 166.63 23.06 166.63 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-9",
    className: "cls-1",
    points: "168.09 23.06 169.29 23.06 169.29 23.06 169.29 33.53 169.29 33.53 168.09 33.53 168.09 33.53 168.09 23.06 168.09 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8",
    className: "cls-4",
    points: "170.43 23.06 170.99 23.06 170.99 23.06 170.99 33.53 170.99 33.53 170.43 33.53 170.43 33.53 170.43 23.06 170.43 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6",
    className: "cls-1",
    points: "164.22 21.79 172.55 21.79 172.55 21.79 172.55 22.76 172.55 22.76 164.22 22.76 164.22 22.76 164.22 21.79 164.22 21.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8",
    className: "cls-1",
    points: "164.77 16.84 166.33 16.84 166.33 16.84 166.33 18.66 166.33 18.66 164.77 18.66 164.77 18.66 164.77 16.84 164.77 16.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-3",
    className: "cls-1",
    points: "167.41 16.84 167.93 16.84 167.93 16.84 167.93 18.66 167.93 18.66 167.41 18.66 167.41 18.66 167.41 16.84 167.41 16.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6",
    className: "cls-1",
    points: "169.13 16.78 169.59 16.78 169.59 16.78 169.59 18.63 169.59 18.63 169.13 18.63 169.13 18.63 169.13 16.78 169.13 16.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6-1",
    className: "cls-4",
    points: "170.76 16.84 171.21 16.84 171.21 16.84 171.21 18.66 171.21 18.66 170.76 18.66 170.76 18.66 170.76 16.84 170.76 16.84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4047-0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-9",
    className: "cls-1",
    points: "204.72 26.54 204.07 26.54 204.07 26.54 204.07 33.53 204.07 33.53 204.72 33.53 204.72 33.53 204.72 26.54 204.72 26.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-2",
    className: "cls-1",
    points: "201.44 26.47 200.43 26.47 200.43 26.47 200.43 33.53 200.43 33.53 201.44 33.53 201.44 33.53 201.44 26.47 201.44 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-6",
    className: "cls-1",
    points: "200.2 26.47 198.8 26.47 198.8 26.47 198.8 33.53 198.8 33.53 200.2 33.53 200.2 33.53 200.2 26.47 200.2 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-33",
    className: "cls-1",
    points: "197.5 26.47 196.88 26.47 196.88 26.47 196.88 33.53 196.88 33.53 197.5 33.53 197.5 33.53 197.5 26.47 197.5 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-1-5",
    className: "cls-1",
    points: "195.35 26.47 194.74 26.47 194.74 26.47 194.74 33.53 194.74 33.53 195.35 33.53 195.35 33.53 195.35 26.47 195.35 26.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-2-5",
    className: "cls-1",
    points: "194.35 27.03 193.76 27.03 193.76 27.03 193.76 33.53 193.76 33.53 194.35 33.53 194.35 33.53 194.35 27.03 194.35 27.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-4-6",
    className: "cls-1",
    points: "193.34 27.29 192.75 27.29 192.75 27.29 192.75 33.53 192.75 33.53 193.34 33.53 193.34 33.53 193.34 27.29 193.34 27.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-21-4",
    className: "cls-1",
    points: "192.36 27.48 191.74 27.48 191.74 27.48 191.74 33.53 191.74 33.53 192.36 33.53 192.36 33.53 192.36 27.48 192.36 27.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-13-4",
    className: "cls-1",
    points: "191.45 27.71 190.83 27.71 190.83 27.71 190.83 33.53 190.83 33.53 191.45 33.53 191.45 33.53 191.45 27.71 191.45 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-10-3",
    className: "cls-1",
    points: "188.2 27.71 187.58 27.71 187.58 27.71 187.58 33.53 187.58 33.53 188.2 33.53 188.2 33.53 188.2 27.71 188.2 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-28-2",
    className: "cls-1",
    points: "187.19 27.71 186.6 27.71 186.6 27.71 186.6 33.53 186.6 33.53 187.19 33.53 187.19 33.53 187.19 27.71 187.19 27.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-3-0",
    className: "cls-1",
    points: "186.02 28.23 185.4 28.23 185.4 28.23 185.4 33.53 185.4 33.53 186.02 33.53 186.02 33.53 186.02 28.23 186.02 28.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-21",
    className: "cls-1",
    points: "184.81 28.23 184.23 28.23 184.23 28.23 184.23 33.53 184.23 33.53 184.81 33.53 184.81 33.53 184.81 28.23 184.81 28.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-7",
    className: "cls-1",
    points: "178.83 23.06 178.27 23.06 178.27 23.06 178.27 33.53 178.27 33.53 178.83 33.53 178.83 33.53 178.83 23.06 178.83 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-3-1",
    className: "cls-1",
    points: "177 23.06 176.45 23.06 176.45 23.06 176.45 33.53 176.45 33.53 177 33.53 177 33.53 177 23.06 177 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-9-4",
    className: "cls-1",
    points: "175.54 23.06 174.3 23.06 174.3 23.06 174.3 33.53 174.3 33.53 175.54 33.53 175.54 33.53 175.54 23.06 175.54 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-0",
    className: "cls-1",
    points: "173.2 23.06 172.65 23.06 172.65 23.06 172.65 33.53 172.65 33.53 173.2 33.53 173.2 33.53 173.2 23.06 173.2 23.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-1",
    className: "cls-1",
    points: "179.41 21.79 171.21 21.79 171.21 21.79 171.21 22.76 171.21 22.76 179.41 22.76 179.41 22.76 179.41 21.79 179.41 21.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-8",
    className: "cls-1",
    points: "178.86 16.84 177.27 16.84 177.27 16.84 177.27 18.66 177.27 18.66 178.86 18.66 178.86 18.66 178.86 16.84 178.86 16.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-3-2",
    className: "cls-1",
    points: "176.22 16.84 175.7 16.84 175.7 16.84 175.7 18.66 175.7 18.66 176.22 18.66 176.22 18.66 176.22 16.84 176.22 16.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6-7",
    className: "cls-1",
    points: "174.47 16.78 174.04 16.78 174.04 16.78 174.04 18.63 174.04 18.63 174.47 18.63 174.47 18.63 174.47 16.78 174.47 16.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6-1-5",
    className: "cls-1",
    points: "172.87 16.84 172.42 16.84 172.42 16.84 172.42 18.66 172.42 18.66 172.87 18.66 172.87 18.66 172.87 16.84 172.87 16.84"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4180",
    className: "cls-3",
    d: "M156.68,24.55l5.03-2.04,5.1,2.13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5159",
    className: "cls-3",
    d: "M197.12,33.68l.5-29.36.69-.55v-.37l.14.39.55.59.37,29.29v-.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5161",
    className: "cls-4",
    d: "M198.72,2.65c0,.23-.16.39-.34.41-.21,0-.34-.18-.37-.39h0c0-.23.16-.41.34-.41.21,0,.34.18.37.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5163",
    className: "cls-3",
    d: "M198.26,4l.09-3.34h-.5v-.09h.5v-.57h.09v.57h.48v.09h-.48v3.36h-.18v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5165",
    className: "cls-3",
    d: "M198.31,1.19l-.23.39.21.43h.16l.23-.41-.25-.41h-.14.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path5315",
    className: "cls-3",
    d: "M197.46,11.58c.59.18,1.14.14,1.69.05"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g4645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4622",
    className: "cls-3",
    d: "M226.07,34.3l3.65-.12v-11.81l.46-.38v-.14h-.2v-.23l-.38.09-.2-.06c.14-2.92-.46-5.04-2.6-5.53v-1.01l.23-.06v-.26h-.26l.06-.46h.2v-.23l-.75-.67v-2.11h.26v-.43h-.26v-1.42h-.46.06v1.39h-.26v.41h.23v2.11l-.69.67v.23h.17l.06.46h-.26v.26l.23.06v1.01c-2.14.49-2.78,2.6-2.63,5.53l-.17.06-.35-.09v.23h-.23v.14l.43.38v1.42h-1.42v-3.5h.49l-.06-.23h-.2l-.03-.23h-.29v-1.3c-.12-.55-.17-1.27-1.04-1.56v-.96l-.12-.93-.12.93-.06.93c-.26.14-.81.61-.87,1.5v1.33h-.41v.23h-.2v.29h.58v3.59c-.2.49-.26,1.1-.75,1.36h-.55v-3.15c-.38-.72-.46-1.5-1.74-2.23v-1.36l-.46-.23v-1.3c-.06-.35-.12-.75-.23,0l-.06,1.3-.41.29v1.3c-1.22.49-1.42,1.33-1.79,2.11v1.79l-.38.55-.43.06v-.49h-.23v.46l-.41.58v.87h-1.59l-.06,8.62,12.79-.23h0l3.65.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4672"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect4652",
    className: "cls-1",
    points: "220.26 20.36 219.56 20.36 219.56 20.36 219.56 21.8 219.56 21.8 220.26 21.8 220.26 21.8 220.26 20.36 220.26 20.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-0",
    className: "cls-1",
    d: "M215.74,29.88c-.67-.38-1.33-.38-2.03,0h0v4.02h0c.64.2,1.01.23,2.03,0h0v-4.02Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21858",
    className: "cls-1",
    points: "227.4 25.16 223.24 25.16 223.24 25.16 223.24 33.7 223.24 33.7 227.4 33.7 227.4 33.41 227.4 25.16 227.4 25.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4195",
    className: "cls-3",
    d: "M82.85,32.48c.05-6.42.72-11.42,1.42-17.4,3.32-2.16,8.09-5.57,12.09-6.24.88,1.39,2.37,2.24,2.6,4.18l1.29.34.13,5.18,4.02.44.64,1.01h1.42l.77-1.01,5.72.1c11.57.23,10.88,2.68,12.99,4.61l.52,3.61,2.47.1.13,2.58-.13,4.28h-46.24l.13-1.8.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197",
    className: "cls-2",
    d: "M103.57,32.58h3.02v-3.61c-.18-1.62-2.73-2.09-3.12,0l.1,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-0",
    className: "cls-2",
    d: "M99.68,32.58h2.53v-3.5c-.15-1.57-2.29-2.01-2.6,0l.08,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-2",
    className: "cls-2",
    d: "M95.89,32.58h2.4v-3.5c-.15-1.57-2.16-2.01-2.47,0l.08,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-3",
    className: "cls-2",
    d: "M92.13,32.58h2.27v-3.45c-.13-1.55-2.06-1.98-2.35,0l.08,3.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5",
    className: "cls-2",
    d: "M89.14,32.58h1.75v-3.25c-.1-1.47-1.6-1.86-1.83,0l.05,3.25h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5-3",
    className: "cls-2",
    d: "M87.29,32.58h1.26v-3.09c-.08-1.39-1.13-1.78-1.29,0l.05,3.09h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5-6",
    className: "cls-2",
    d: "M85.71,32.58h.88v-2.89c-.05-1.29-.8-1.65-.9,0v2.89h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5-9",
    className: "cls-3",
    d: "M84.42,32.58h.75v-2.65c-.05-1.19-.7-1.52-.77,0v2.65h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-1",
    className: "cls-2",
    d: "M110.7,32.2h2.11v-2.78c-.13-1.25-1.92-1.6-2.18,0l.06,2.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-58",
    className: "cls-2",
    d: "M114.86,32.58h2.14v-3.17c-.13-1.42-1.93-1.83-2.22,0l.08,3.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-6",
    className: "cls-2",
    d: "M117.95,32.58h1.75v-2.96c-.1-1.34-1.6-1.7-1.83,0l.05,2.96h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-4",
    className: "cls-2",
    d: "M120.56,32.58h1.52v-2.65c-.1-1.19-1.37-1.52-1.55,0l.05,2.65h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-7",
    className: "cls-2",
    d: "M123.01,32.58h1.13v-2.53c-.08-1.13-1.03-1.44-1.16,0v2.53h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12",
    className: "cls-2",
    d: "M99.29,25.62h2.65v-2.76c-.15-1.24-2.4-1.6-2.73,0l.08,2.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2",
    className: "cls-2",
    d: "M95.58,25.44h2.53v-2.45c-.15-1.11-2.29-1.39-2.6,0l.08,2.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8",
    className: "cls-2",
    d: "M92.26,25.44h2.01v-2.19c-.13-.98-1.83-1.26-2.09,0l.05,2.19h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6",
    className: "cls-2",
    d: "M89.5,25.73h1.65v-1.78c-.1-.8-1.49-1.03-1.7,0l.05,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1",
    className: "cls-2",
    d: "M87.49,25.78h1.39v-1.62c-.08-.72-1.26-.93-1.42,0l.05,1.62h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1-2",
    className: "cls-2",
    d: "M85.69,26.01h1.39v-1.55c-.08-.7-1.26-.88-1.42,0l.05,1.55h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-0",
    className: "cls-2",
    d: "M96.51,19.23l2.27-.36v-2.76c-.13-1.21-2.06-1.26-2.35.36l.08,2.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-3",
    className: "cls-2",
    d: "M93.34,19.54l2.16-.34v-2.45c-.13-1.08-1.96-1.11-2.22.34l.08,2.42-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-5",
    className: "cls-2",
    d: "M90.48,19.98l1.73-.26v-2.19c-.1-.98-1.57-1.03-1.78.28l.05,2.19v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-14",
    className: "cls-2",
    d: "M88.14,20.62l1.39-.21v-1.78c-.08-.8-1.26-.82-1.44.23l.05,1.78v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1-4",
    className: "cls-2",
    d: "M86.41,20.96l1.19-.18v-1.62c-.08-.72-1.08-.77-1.21.18v1.62h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1-2-2",
    className: "cls-2",
    d: "M84.86,21.42l1.19-.18v-1.55c-.08-.7-1.08-.72-1.21.18v1.55h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-1-3",
    className: "cls-2",
    d: "M107.67,24.69l2.53.21v-2.11c-.15-.95-2.29-1.39-2.6-.21l.08,2.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-58-6",
    className: "cls-2",
    d: "M111.79,25l2.14.18v-2.01c-.13-.93-1.93-1.31-2.22-.18l.08,2.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-6-4",
    className: "cls-2",
    d: "M114.91,25.26l1.75.13v-1.88c-.1-.85-1.6-1.21-1.83-.15l.05,1.88.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-4-2",
    className: "cls-2",
    d: "M117.49,25.47l1.52.13v-1.68c-.1-.77-1.37-1.08-1.55-.13l.05,1.68h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-7-3",
    className: "cls-2",
    d: "M119.96,25.65l1.13.08v-1.6c-.08-.72-1.03-1.01-1.16-.1v1.6l.03.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4955",
    className: "cls-3",
    d: "M46.33,34.77v-12.94h13.19v12.94h-13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-0",
    className: "cls-2",
    d: "M47.57,34.71h2.11v-3.2c0-2.3-1.99-3.02-2.11.06v3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-0-6",
    className: "cls-2",
    d: "M56.09,34.77h2.11v-3.2c0-2.3-1.99-3.02-2.11.06v3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-0-3",
    className: "cls-2",
    d: "M50.59,34.74h4.57v-4.63c.06-3.36-4.29-4.35-4.57.09v4.57-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect5017",
    className: "cls-4",
    points: "44.86 22.49 61 22.49 61 22.49 61 23.95 61 23.95 44.86 23.95 44.86 23.95 44.86 22.49 44.86 22.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect5017-4",
    className: "cls-4",
    points: "47.88 22.64 57.58 22.64 57.58 22.64 57.58 23.51 57.58 23.51 47.88 23.51 47.88 23.51 47.88 22.64 47.88 22.64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscape1);
export default __webpack_public_path__ + "static/media/Landscape_1.46d2cc50de76ac148d85e260dbb0352c.svg";
export { ForwardRef as ReactComponent };